module.exports = __webpack_public_path__ + "hyperion-v2-static/img/seerist-feature-popup.45c1e95d.png";